module.exports = __webpack_public_path__ + "amcharts/images/dragIconRoundSmallH.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRoundSmallH.png
// module id = 260
// module chunks = 0